import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  contentChild,
  input,
  output,
  TemplateRef,
} from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { ButtonPassThrough } from 'primeng/button';
import {
  FileSelectEvent,
  FileUpload,
  FileUploadModule,
} from 'primeng/fileupload';

import { getColor } from '../../helpers/theme-utils/colors';
import { SharedButtonComponent } from '../button/button.component';
import { SharedButtonType } from '../button/button.constants';

export interface UploadDocumentErrorContext {
  $implicit: File;
  errors: string[];
}

@Component({
  selector: 'shared-upload-document',
  imports: [
    CommonModule,
    FileUploadModule,
    SharedButtonComponent,
    TranslocoDirective,
  ],
  templateUrl: './upload-document.component.html',
  styleUrl: './upload-document.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UploadDocumentComponent {
  readonly files = input<File[]>([]);
  readonly errors = input<ReadonlyMap<string, string[]>>(new Map());
  readonly disabled = input(false);
  readonly multiple = input(true);
  readonly maxFileSize = input(4 * 1024 * 1024 * 1024);
  readonly helperText = input('uploadHint');
  readonly standardLayout = input(true);
  readonly filesChange = output<File[]>();
  readonly errorsTemplate =
    contentChild<TemplateRef<UploadDocumentErrorContext>>('uploadErrors');

  readonly sharedButtonType = SharedButtonType;
  readonly addDocumentButtonPT: ButtonPassThrough = {
    root: {
      style: {
        background: getColor('UiWhite'),
      },
    },
  };

  onSelectedFiles(event: FileSelectEvent): void {
    this.filesChange.emit(event.currentFiles);
  }

  removeFile(event: Event, fileUpload: FileUpload, index: number): void {
    fileUpload.remove(event, index);
    this.filesChange.emit([...fileUpload.files]);
  }

  choose(fileUpload: FileUpload): void {
    fileUpload.choose();
  }
}
